import React, { useState, useEffect } from 'react';
import cs from 'classnames';
// import './index.less'
import styles from './index.less';
import { TLang } from '@/utils/lang';

const prefix = 'qyf';

const SMS = (props: any) => {
  // class SMS extends React.Component {
  const { resetSend, phone = '', warnText = '', values = [] } = props;
  let timer: any = null;

  const [count, setCount] = useState<number>(60);

  useEffect(() => {
    if (count) {
      onTimer(Number(count));
    }
  }, [count]);

  const onTimer = (count) => {
    let index = count;
    if (count <= 0) {
      setCount(0);
      clearTimeout(timer);
      timer = null;
      return;
    }
    setCount(index--);
    timer = setTimeout(() => {
      onTimer(--count);
    }, 1000);
  };

  const handlePhone = (phone) => {
    if (phone === '') return phone;
    return `${phone.slice(0, 3)}****${phone.slice(7)}`;
  };

  /** 超时重新获取验证码 */
  const resetSendSms = () => {
    onTimer(60);
    resetSend && resetSend(phone);
  };

  return (
    <div className={`${styles.qyfInputtedContianerA}`}>
      <div className={`${styles.qyfPointSms}`}>
        <div>{TLang('验证码已发送至', 'home', false, false, null)}{handlePhone(phone || values)}</div>
        <div className={`${styles.qyWarnText}`}>{warnText}</div>
      </div>
      <ul className={`${styles.qyfSms}`}>
        <li>
          <span
            className={`${styles.qyfNo} ${styles.qyfNoSms} ${styles[values[0] && 'have']}`}
          >
            {values[0]}
          </span>
        </li>
        <li>
          <span
            className={`${styles.qyfNo} ${styles.qyfNoSms} ${styles[values[1] && 'have']}`}
          >
            {values[1]}
          </span>
        </li>
        <li>
          <span
            className={`${styles.qyfNo} ${styles.qyfNoSms} ${styles[values[2] && 'have']}`}
          >
            {values[2]}
          </span>
        </li>
        <li>
          <span
            className={`${styles.qyfNo} ${styles.qyfNoSms} ${styles[values[3] && 'have']}`}
          >
            {values[3]}
          </span>
        </li>
        <li>
          <span
            className={`${styles.qyfNo} ${styles.qyfNoSms} ${styles[values[4] && 'have']}`}
          >
            {values[4]}
          </span>
        </li>
        <li>
          <span
            className={`${styles.qyfNo} ${styles.qyfNoSms} ${styles[values[5] && 'have']}`}
          >
            {values[5]}
          </span>
        </li>
      </ul>
      <div className={`${styles.qyfTip} ${styles.qyfTipSms}`}>
        {count === 0 ? (
          <a onTouchStart={() => resetSendSms()}>{TLang('重新发送', 'home', false, false, null)}</a>
        ) : (
          <>
            {TLang('重新发送', 'home', false, false, null)}(
            <i style={`${count}`.length === 1 ? { width: '10px' } : {}}>
              {count}
            </i>
            S)
          </>
        )}
      </div>
    </div>
  );
};
export default SMS;
